module.exports = __webpack_public_path__ + "img/mllogo.8db93e80.png";